import { Coverage, COVERAGE_COLLECTION_NAME, Segment } from 'models';
import { CollectionState, useCollectionContext } from 'components/settings/collectionContext';
import { where } from 'firebase/firestore';
import { useContractContext } from './contractContext';
import { useSection } from './contractClauses';
import './contract.css';

const CoverageItem = ({ record }: { record: Coverage }) => {
    const { contract, selection, setContractSections } = useContractContext();
    const section = useSection(selection || '');
    const existingSection = contract.contractSections.find((c) => c.sectionIndexId === selection);
    const checked = !!existingSection?.segments.find(
        (segment) => segment.coverageIndexId === record.indexId()
    );
    const onChange = () =>
        setContractSections(
            contract.contractSections.map((contractSection) => {
                if (contractSection.sectionIndexId !== selection) {
                    return contractSection;
                }
                return {
                    ...contractSection,
                    segments: checked
                        ? contractSection.segments.filter(
                              (segment) => segment.coverageIndexId !== record.indexId()
                          )
                        : contractSection.segments.concat([
                              new Segment({ coverageIndexId: record.indexId() }),
                          ]),
                };
            })
        );
    return (
        <div key={record.id} style={{ margin: '8px 11px 1px 11px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                    onChange={onChange}
                    disabled={!section?.coverage}
                    checked={checked}
                    type="checkbox"
                    placeholder=""
                    style={{ marginRight: '11px' }}
                />
                <div key={`${record.id}-name-${record.name}`}>{record.name}</div>
            </div>
        </div>
    );
};

export const CoveragesSidePanel = () => {
    const { contract, selection } = useContractContext();
    const [records] = useCollectionContext(COVERAGE_COLLECTION_NAME, [
        where('productTypeIndexIds', 'array-contains', contract?.productTypeIndexId),
    ]) as CollectionState<Coverage>;
    const section = useSection(selection || '');
    return (
        <div className="contractClausesBox" style={{}}>
            <div
                style={{
                    background: '#F4F4F4',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '14px',
                }}
            >
                Coverages
            </div>
            <div className="contractClausesBoxList">
                <div
                    style={{ paddingBottom: '7px' }}
                    title={section?.coverage ? '' : 'Select a coverage section first'}
                >
                    {records?.map((record) => {
                        return (
                            <CoverageItem record={record} key={`${record.id}-${record.checked}`} />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
